import PageBase from '@/sag-core/base/PageBase'
import tools from '@/sag-core/tools'
import pageStore from './store'

const pageInfo = {
    serviceName: 'APSPPAUI06',
    pageStore: pageStore
}
export default {
    pageInfo: pageInfo,
    pageInit(){
        const page = new PageBase(pageInfo)
        tools.mergeDeep(this, page)
    }
}